import { useTranslation } from 'react-i18next';

import SvgIcon from '@/components/SvgIcon/SvgIcon';
import { useOpenChat, useOwnPlans } from '@/hooks';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';

import styles from './RunOutChecks.module.sass';

export interface RunOutChecksProps {
  onClick: () => void;
}

export const RunOutChecks = ({ onClick }: RunOutChecksProps) => {
  const { t } = useTranslation();

  const { data: userData } = useAppSelector(userSelectors.getUserSlice);

  const needTopUpBalance = userData?.extBalance === 0;
  // Nothing to buy (e.g. the Pro plans are locked): the top-up panel would be
  // empty, so the banner opens the support chat (Telegram support as fallback).
  const hasPlansToBuy = useOwnPlans().length > 0;
  const { handleOpenChat } = useOpenChat();

  if (!needTopUpBalance) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.panel}
      onClick={hasPlansToBuy ? onClick : handleOpenChat}
    >
      <div className={styles.title}>
        {t('translation.run_out_checks.title')}
      </div>

      <div className={styles.info}>
        <SvgIcon name="aml" className={styles.aml} />
        {t('translation.buy_credits_title')}
        <SvgIcon name="arrow-right" className={styles.arrow} />
      </div>
    </button>
  );
};
